class ObjectIdFactory {
    setup(ObjectIdClass) {
        this.ObjectIdClass = ObjectIdClass
    }


    /*
     * This method create an ObjectId
     * @param value {string}
     **/
    create(value) {
        if (typeof value === "string") return new this.ObjectIdClass(value)
        if (Array.isArray(value)) return value.map((id) => new this.ObjectIdClass(id))
        return value;
    }

}

export default new ObjectIdFactory()
